// The shell around every logged-in page that isn't inside a product: the header, the page, the
// footer with the help address (decision 38). Holding pages and "nothing here" use it too, and the
// payment banner shows on every one of them while a payment is overdue (docs/data-model.md 3.2).
import { useEffect } from 'react'
import { SITE, setTitle } from '../config/site.js'
import { useMember } from '../app/member.jsx'
import { useViewingAs } from '../lib/viewAs.jsx'
import { useLibraryModel } from '../library/useModel.js'
import { usePhone } from '../lib/media.js'
import { Link } from '../lib/router.jsx'
import { Header } from './Header.jsx'
import { PaymentBanner } from './PaymentBanner.jsx'
import '../styles/shell.css'

export function Footer({ phone }) {
  if (phone) {
    return (
      <footer className="ph-footer">
        <span>{SITE.company}</span>
        <span className="ph-footer-links">
          <a href={SITE.termsUrl}>Terms</a>
          <a href={SITE.privacyUrl}>Privacy</a>
          <span>Help: {SITE.helpEmail}</span>
        </span>
      </footer>
    )
  }
  return (
    <footer className="sh-footer">
      <span>{SITE.company}</span>
      <div className="sh-footer-links">
        <a href={SITE.termsUrl}>Terms</a>
        <a href={SITE.privacyUrl}>Privacy</a>
        <span>Help: {SITE.helpEmail}</span>
      </div>
    </footer>
  )
}

// A plain page in the shell's look: an eyebrow, a heading, a line or 2 and what to do next
export function ShellPage({ title, eyebrow, heading, children }) {
  const { me, ensureLibrary, markRead } = useMember()
  const model = useLibraryModel()
  const phone = usePhone()
  // viewing as a member, opening the bell marks nothing read (lib/viewAs.jsx)
  const viewingAs = useViewingAs()
  useEffect(() => { setTitle(title) }, [title])
  useEffect(() => { ensureLibrary() }, [ensureLibrary])
  return (
    <div className="sh-page">
      <Header model={model} person={me.person} phone={phone} onOpenBell={viewingAs ? undefined : markRead} />
      {model && <PaymentBanner text={model.banner} target={model.bannerFor} phone={phone} />}
      <main className="sh-main">
        {eyebrow && <div className="sh-eyebrow">{eyebrow}</div>}
        <h1 className="sh-h1">{heading}</h1>
        {children}
      </main>
      <Footer phone={phone} />
    </div>
  )
}

export function BackToLibrary() {
  return <p className="sh-actions-row"><Link to="/" className="btn btn-ink">Back to your library</Link></p>
}

export function NotFound() {
  return (
    <ShellPage title="Nothing here" heading="There's nothing here">
      <p className="sh-lede">This page isn't part of anything you have. Everything you have is in your library.</p>
      <BackToLibrary />
    </ShellPage>
  )
}
